import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Renonciation au droit de rétractation (art. L221-28 13° C. consom.) avant le
 * paiement Solo. Même case et même texte (`legal:withdrawal_waiver.*`) que la
 * page Tarifs date-polls ; utilisée par la modale de quota et PricingHub (#1470).
 * Le bouton de paiement associé reste bloqué tant qu'elle n'est pas cochée.
 */
export interface WithdrawalWaiverCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: boolean;
  className?: string;
  testId?: string;
}

export function WithdrawalWaiverCheckbox({
  checked,
  onChange,
  error = false,
  className = "",
  testId = "withdrawal-waiver",
}: WithdrawalWaiverCheckboxProps) {
  const { t } = useTranslation("legal");
  return (
    <label
      className={`flex items-start gap-2 cursor-pointer text-[11px] leading-snug rounded-md px-2 py-1.5 border transition-colors text-left ${
        error
          ? "border-destructive/70 bg-destructive/20 text-destructive"
          : "border-border/50 bg-muted/50 text-muted-foreground"
      } ${className}`}
      data-testid={testId}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-3.5 h-3.5 flex-shrink-0 accent-primary cursor-pointer"
        aria-invalid={error}
        data-testid={`${testId}-checkbox`}
      />
      <span className="break-words min-w-0">
        {t("legal:withdrawal_waiver.consent")}{" "}
        <a
          href="/docs/cg-u"
          target="_blank"
          rel="noopener"
          className="text-primary underline hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          {t("legal:withdrawal_waiver.details")}
        </a>
      </span>
    </label>
  );
}
